import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from '../../connection.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css']
})
export class ResetComponent implements OnInit {

	lower = true; upper = true; len = true; num = true; spec = true; captchaVal = false; captcha = ''; signLoader = false; isShow = true; isShow1 = true; icon = "fa fa-eye-slash"; icon1 = "fa fa-eye-slash";resetToken = ""; resetVerify = "";

  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute) { 

	  	this.actRoute.params.subscribe((params) => {
			this.resetToken = this.actRoute.snapshot.queryParamMap.get('token');
			this.resetVerify = this.actRoute.snapshot.queryParamMap.get('verify');
			if (this.resetToken == null || this.resetToken == undefined || this.resetToken == "undefined" || this.resetVerify == null || this.resetVerify == undefined || this.resetVerify == "undefined") {
				this.alert.error("Invalid Request");
				this.route.navigate(['login']);
			}
			var d = {"token": this.resetToken};
			this.conn.postUrl('users/getcode', d).subscribe((res :any)=>{
				if(res.success == 0){
					this.route.navigate(['login']);
					this.alert.error(res.msg);
				}
			});
		});
  }

  ngOnInit() {
  }

  typePwd(pwd) {
		if (pwd != null && pwd != undefined && pwd != "") {
			this.lower = true; this.upper = true; this.len = true; this.num = true; this.spec = true;
			let lowerChars = /[a-z]/g;
			let upperChars = /[A-Z]/g;
			let numbers = /[0-9]/g;
			let specials = /\W|_/g;
			if (pwd.length < 8) { this.len = false; return; }
			if (pwd.match(lowerChars) == null) { this.lower = false; return; }
			if (pwd.match(upperChars) == null) { this.upper = false; return; }
			if (pwd.match(numbers) == null) { this.num = false; return; }
			if (pwd.match(specials) == null) { this.spec = false; return; }
		}
	}

  showPass(){
	   this.isShow = (this.isShow) ? false : true;
	   this.icon = (this.isShow) ? "fa fa-eye-slash" : "fa fa-eye";
	}

  showPass1() {
    this.isShow1 = (this.isShow1) ? false : true;
    this.icon1 = (this.isShow1) ? "fa fa-eye-slash" : "fa fa-eye";
  }

  resolved(res: string) {
		if (res != "") { this.captcha = res; this.captchaVal = true; }
	}

  submitFunc(reset: NgForm) {
		// if (!this.captchaVal) {
		// 	this.alert.error("Please complete captcha");
		// 	return;
		// }
		this.captcha = "";
		this.signLoader = true;
		var data = reset.value;
		data.token = this.resetToken;
		data.verify = this.resetVerify;
		this.conn.postUrl('users/resetPassword', data).subscribe((res: any) => {
			if (res.status == 1) {
				this.alert.success(res.msg);
				this.route.navigate(['login']);
			}else if (res.status == 2) {
				this.route.navigate(['login']);
				this.alert.error(res.msg);
			}else {
				this.alert.error(res.msg);
			}
			reset.resetForm();
			this.signLoader = false;
		});
	}

	removeSpace(event: any) {
		if (event.code === 'Space') {
			event.preventDefault();
		}
	}
}
